/**
 * Every analytics event name RMS pushes to the GTM data layer.
 *
 * Each value must have a matching Custom Event trigger AND a GA4 Event tag in container
 * GTM-NV9PKNM; adding a value here without adding both means the event is silently ignored.
 * See src/app/core/services/analytics/CLAUDE.md for the full checklist.
 */
export enum ANALYTICS_EVENTS {
  CompanyView = 'company_view',
  PortfolioView = 'portfolio_view',
  IndicationView = 'indication_view',
  ConferenceView = 'conference_view',
  HeadlineView = 'headline_view',
  BlackbirdNavClick = 'blackbird_nav_click',
  BlackbirdButtonClick = 'blackbird_button_click',
  ComparisonView = 'comparison_view',
  ComparisonViewToggle = 'comparison_view_toggle',
  DeckUploadStarted = 'deck_upload_started',
  DeckUploadCompleted = 'deck_upload_completed',
  DeckComparisonRequested = 'deck_comparison_requested'
}
